module.exports = __webpack_public_path__ + "static/media/logo_uvm.b43d09af.png";